import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { salaryComponentCreate, salaryComponentDelete, salaryComponentList, salaryComponentView } from "../../../services/payroll";

const COMP_TYPES = [
  { value: "earning",   label: "Earning"   },
  { value: "deduction", label: "Deduction" },
];

const CALC_TYPES = [
  { value: "fixed",      label: "Fixed Amount" },
  { value: "percentage", label: "Percentage"   },
];

export default function SalaryComponents() {
  const [list, setList]               = useState([]);
  const [compOptions, setCompOptions] = useState([]);
  const [show, setShow]               = useState(false);
  const [cid, setCid]                 = useState(0);
  const [componentName, setComponentName] = useState("");
  const [componentType, setComponentType] = useState("");
  const [calcType, setCalcType]       = useState(CALC_TYPES[0]);
  const [percentageOf, setPercentageOf] = useState("");
  const [percentageValue, setPercentageValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => { loadList(); }, []);

  function loadList() {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    salaryComponentList(temp).then((res) => {
      if (res?.status) {
        setList(res.data);
        setCompOptions(res.data.filter((c) => c.component_type === "earning").map((c) => ({ value: c.id, label: c.component_name })));
      }
    });
  }

  function handleAdd() {
    setCid(0); setComponentName(""); setComponentType(""); setCalcType(CALC_TYPES[0]);
    setPercentageOf(""); setPercentageValue(""); setErrorMessage(""); setShow(true);
  }

  function handleEdit(id) {
    setCid(id); setErrorMessage(""); setShow(true);
    salaryComponentView(id).then((res) => {
      if (res?.status) {
        const d = res.data;
        setComponentName(d.component_name);
        setComponentType(COMP_TYPES.find((t) => t.value === d.component_type) || "");
        setCalcType(CALC_TYPES.find((t) => t.value === d.calc_type) || CALC_TYPES[0]);
        setPercentageOf(compOptions.find((c) => c.value === d.percentage_of) || "");
        setPercentageValue(d.percentage_value || "");
      }
    });
  }

  function handleClose() { setShow(false); }

  function handleDelete(id) {
    Swal.fire({
      text: "Delete this component?", icon: "warning", showCancelButton: true,
      confirmButtonColor: "#ac0404", cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete", allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        salaryComponentDelete(id).then((res) => {
          if (res?.status) { toast.success(res.message); loadList(); }
          else toast.error(res?.message || "Cannot delete");
        });
      }
    });
  }

  function handleSubmit() {
    setErrorMessage("");
    if (!componentName.trim()) { setErrorMessage("Please enter component name"); return; }
    if (!componentType)        { setErrorMessage("Please select component type"); return; }
    if (calcType?.value === "percentage" && !percentageValue) { setErrorMessage("Please enter percentage value"); return; }

    const temp = new FormData();
    temp.append("id", cid);
    temp.append("component_name",  componentName);
    temp.append("component_type",  componentType.value);
    temp.append("calc_type",       calcType?.value || "fixed");
    if (calcType?.value === "percentage") {
      if (percentageOf) temp.append("percentage_of", percentageOf.value);
      temp.append("percentage_value", percentageValue);
    }
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");

    salaryComponentCreate(temp).then((res) => {
      if (res?.status) { toast.success(res.message); handleClose(); loadList(); }
      else setErrorMessage(res?.message || "Something went wrong");
    });
  }

  const columnDefs = [
    { headerName: "Component Name", field: "component_name", sortable: true, filter: true, floatingFilter: true, resizable: true, cellStyle: { textAlign: "left" } },
    { headerName: "Type",      field: "component_type", width: 120, resizable: true,
      cellRenderer: (p) => <span className={`badge ${p.value === "earning" ? "bg-success" : "bg-danger"}`}>{p.value}</span> },
    { headerName: "Calc Type", field: "calc_type",      width: 140, resizable: true },
    { headerName: "% Value",   field: "percentage_value", width: 100, resizable: true },
    {
      headerName: "Actions", field: "id", width: 120, filter: false, resizable: true,
      cellRenderer: (p) => (
        <div className="text-center">
          <a onClick={() => handleEdit(p.value)} className="btn-sm btn-info me-2"><i className="fa fa-edit" /></a>
          <a onClick={() => handleDelete(p.value)} className="btn-sm btn-danger"><i className="fa fa-trash" /></a>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Salary Components</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Payroll</a></li>
            <li className="breadcrumb-item active" aria-current="page">Salary Components</li>
          </ol>
        </div>
      </div>

      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a onClick={handleAdd} className="btn my-1 me-2 btn-success tx-teko">Add</a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact columnDefs={columnDefs} rowData={list} pagination paginationPageSize={10} suppressDragLeaveHidesColumns />
                </div>
              </div>

              <Modal show={show} onHide={handleClose}>
                <Modal.Header><h4>{cid === 0 ? "Add" : "Edit"} Salary Component</h4></Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12} className="mb-3">
                      <label className="mb-2">Component Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" placeholder="e.g. Basic Salary" value={componentName} onChange={(e) => setComponentName(e.target.value)} />
                    </Col>
                    <Col lg={12} md={12} className="mb-3">
                      <label className="mb-2">Type <span className="text-danger">*</span></label>
                      <Select className="default-select" placeholder="Select Type" options={COMP_TYPES} value={componentType} onChange={(e) => setComponentType(e)} isClearable />
                    </Col>
                    <Col lg={12} md={12} className="mb-3">
                      <label className="mb-2">Calculation Type</label>
                      <Select className="default-select" options={CALC_TYPES} value={calcType} onChange={(e) => setCalcType(e)} />
                    </Col>
                    {calcType?.value === "percentage" && (
                      <>
                        <Col lg={12} md={12} className="mb-3">
                          <label className="mb-2">Percentage of</label>
                          <Select className="default-select" placeholder="Select base component" options={compOptions} value={percentageOf} onChange={(e) => setPercentageOf(e)} isClearable />
                        </Col>
                        <Col lg={12} md={12} className="mb-3">
                          <label className="mb-2">Percentage Value (%) <span className="text-danger">*</span></label>
                          <input type="number" className="form-control" placeholder="e.g. 40" value={percentageValue} onChange={(e) => setPercentageValue(e.target.value)} />
                        </Col>
                      </>
                    )}
                    {errorMessage && <span className="text-danger">{errorMessage}</span>}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a onClick={handleSubmit} className="btn btn-success">{cid === 0 ? "Submit" : "Update"}</a>
                  <a onClick={handleClose} className="btn btn-secondary">Close</a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
}
